import { useState } from "react";

import { Sidebar } from "../sidebar";
import { AvatarMenu } from "../avatar-menu";
import { Box } from "@mui/material";

export function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex bg-white m-0 p-3 md:px-12 text-primary-main border-solid border-black-1 w-full items-center">
      <div className="flex w-full items-center gap-10">
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => {
            setSidebarOpen(false);
          }}
        />
        <Box
          component="img"
          sx={{
            height: 40,
            width: 240,
          }}
          alt="About Us"
          src="/assets/icon/il_app_logo.png"
        />
      </div>
      <AvatarMenu />
    </div>
  );
}
